import stcLogo from "@/assets/partners/stc.png";
import ncmLogo from "@/assets/partners/ncm.png";
import srcLogo from "@/assets/partners/src.png";
import kfcaLogo from "@/assets/partners/kfca.png";
import healthHoldingLogo from "@/assets/partners/health-holding.png";
import znenLogo from "@/assets/partners/znen.png";
import senkenLogo from "@/assets/partners/senken.png";
import inmotionLogo from "@/assets/partners/inmotion.png";
import kingsongLogo from "@/assets/partners/kingsong.png";
import doohanLogo from "@/assets/partners/doohan.png";
import xstoLogo from "@/assets/partners/xsto.png";

const partners = [
  { name: "STC", logo: stcLogo },
  { name: "Saudi Red Crescent Authority", logo: srcLogo },
  { name: "National Center for Meteorology", logo: ncmLogo },
  { name: "King Fahd Causeway Authority", logo: kfcaLogo },
  { name: "Health Holding", logo: healthHoldingLogo },
  { name: "ZNEN", logo: znenLogo },
  { name: "Senken Group", logo: senkenLogo },
  { name: "InMotion", logo: inmotionLogo },
  { name: "Kingsong", logo: kingsongLogo },
  { name: "Doohan", logo: doohanLogo },
  { name: "XSTO", logo: xstoLogo },
];

interface PartnerLogosProps {
  title?: string;
}

const PartnerLogos = ({ title = "Trusted by Leading Organizations" }: PartnerLogosProps) => {
  // Duplicate partners array for seamless loop
  const duplicatedPartners = [...partners, ...partners];

  return (
    <section className="py-16 bg-secondary/30 overflow-hidden">
      <div className="container mx-auto px-6">
        <h3 className="text-center text-lg text-muted-foreground mb-10">{title}</h3>
      </div>
      <div className="relative w-full">
        {/* Gradient overlays for fade effect */}
        <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-secondary/30 to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-secondary/30 to-transparent z-10 pointer-events-none" />
        
        <div className="flex animate-marquee items-center">
          {duplicatedPartners.map((partner, index) => (
            <div
              key={`${partner.name}-${index}`}
              className="flex-shrink-0 h-16 md:h-20 mx-8 md:mx-12 flex items-center justify-center group cursor-pointer"
              title={partner.name}
            >
              <img 
                src={partner.logo} 
                alt={partner.name} 
                className="h-full w-auto object-contain brightness-0 invert opacity-60 group-hover:opacity-100 group-hover:scale-110 transition-all duration-300 ease-out"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnerLogos;
